import React, { useEffect, useRef, useState } from 'react';
import usePopupStore from "../store/global"
import Skeleton from './skeleton';
import useFetchLanguage from './hooks/useFetchLanguage';
import useLanguageStore from '../store/language';
import usetranslatedTextStore from '../store/translatedText';
import useTranslatedText from './hooks/useTranslatedText';
import useMultipleFetchListen from './hooks/useMultiFetchListen';

import useAudioStore from '../store/audio';
import useAudioPlayer from './hooks/multiAudioPlayer';
const Tttpopup = () => {
  const state = usePopupStore()
  const language = useLanguageStore();
  const translate = usetranslatedTextStore();
  const audioStore = useAudioStore()
  const {translatedText,translatedTextArray,setTranslatedText} = translate;

  // const { setListen, audioresponse, responseData, selectedListenArray , audioclicked } = listen
  // const {audioresponse,setListen} = useListenStore();
  const { popupShown, setState, textareaLen, errormsgDisplay, languageDropdown, selectedText, readValue,skeleton,selectedTextArray,bookType } = state
  let selectedTextData = selectedText;
  let readOnlyState=readValue;
  
  let textareaRef = useRef()
  // let popupCss = popupShown ? 'show' : ''
  let popupDropdown = languageDropdown ? 'show' : ''
  let errormessageDisplay = errormsgDisplay ? "show" : ''
  let characterLengthExceed = errormsgDisplay ? "errorMessage" : ''
  let dropDownDisable = errormsgDisplay ? "disabled" : ''
  let selectedLanguage = usePopupStore.getState().selectedLanguage
  const sourceListen = useMultipleFetchListen();
  const destinationListen = useMultipleFetchListen();
  const sourcAudioPlayer = useAudioPlayer()
  const targetAudioPlayer = useAudioPlayer()

  
  // let { data, loading, error, fetchData } = sourceListen
  useEffect(()=>{ // Source Listen data added to Audio Hook
    if( sourceListen.data.length > 0)
    {
      sourcAudioPlayer.setAudioSources(sourceListen.data)
      targetAudioPlayer.pause()
    }
    if(sourceListen.error !== null ){
      console.log(sourceListen.error)
    }
  },[sourceListen.data,sourceListen.error])
  useEffect(()=>{ // Taget Listen data added to Audio Hook
    if( destinationListen.data.length > 0)
    {
      targetAudioPlayer.setAudioSources(destinationListen.data)
      sourcAudioPlayer.pause()
    }
    if(destinationListen.error !== null ){
      console.log(destinationListen.error)
    }
  },[destinationListen.data,destinationListen.error])

  useEffect(()=>{
    if(translatedTextArray.length)
    {
      let combinedText = "";

      translatedTextArray.forEach(e => {
      combinedText = combinedText + " " + e.translatedText
      });
      setTranslatedText({translatedText:combinedText})
      setState({skeleton:false})
    }
  },[translatedTextArray])
  
  useEffect(() => {
    if (selectedText.length !== 0)
      textareaChangeHandler()
      setTranslatedText({...translate, translatedText:null})
  }, [selectedText])

  const closePopup = () => {
    setState({ popupShown:false,
      selectedLangaugeData:{},
      languageDropdown:false,
      textareaLen:0,
      errormsgdisplay:false,
      // audioclicked:false,
      selectedText:'',
      selectedTextArray:[],
      readValue:true,
      selectedLanguage:false,
      textTranslation:false,
      languageSelected:false,
      selectedLanguageCode:false,
      bookType:'',
      skeleton:false,
      bookType:''})
    setTranslatedText({translatedTextArray:[],
      allLanguage:{},
      translatedText:null,
      targetLanguageCode:'',
      textId:'',
      responseTranslatedText:[]
    })
      audioStore.setAudio({isPlaying:false,
      isPaused:false,
      tracks:[],
      source:null})
      sourcAudioPlayer.stop()
      targetAudioPlayer.stop()
  }
  const onLanguageClickHandler = (event) =>
  {
    let id= event.target.id
    let selectedData= language.language.filter((e)=>{
      return e.code===id
    })[0]
    setState({ ...state, languageDropdown: !languageDropdown, selectedLanguage: selectedData.label,textTranslation:true, selectedLanguageCode:event.target.id})
    targetAudioPlayer.stop()
    language.setLanguage({selectedLangaugeData:selectedData})
  }
  const toggleDropdown = () => {
    setState({ ...state, languageDropdown: !languageDropdown })

  }
  
  useFetchLanguage();
  useTranslatedText();

  const textareaChangeHandler = () => {
    document.addEventListener('contextmenu', event => event.preventDefault());
    var len = textareaRef.current ? textareaRef.current.value.length : 0
    setState({
      ...state,
      textareaLen: len,
      errormsgDisplay: len > 3000 ? true : false
    })
    
  }

  
const sourceListenHandler = (source=true) => {
  // sourcAudioPlayer.setAudioSources(al)
  // const al =[ {audioFilePath: "http://commondatastorage.googleapis.com/codeskulptor-assets/week7-bounce.m4a" },
  //   { audioFilePath: "http://commondatastorage.googleapis.com/codeskulptor-assets/week7-bounce.m4a" },
  //   {audioFilePath:"http://commondatastorage.googleapis.com/codeskulptor-assets/week7-bounce.m4a"}]
  sourceListen.fetchData({source,bookType,selectedTextArray})
  // selectedTextArray
}
const destinationListenHandler = (source=false ) => {
  // targetAudioPlayer.setAudioSources(al)
  // const al = [ {audioFilePath: "http://commondatastorage.googleapis.com/codeskulptor-assets/Collision8-Bit.ogg" },
  //   { audioFilePath: "http://commondatastorage.googleapis.com/codeskulptor-assets/Collision8-Bit.ogg"},
  //   {audioFilePath:"http://commondatastorage.googleapis.com/codeskulptor-assets/Collision8-Bit.ogg"}]
  destinationListen.fetchData({source,bookType,selectedTextArray:translatedTextArray})
  // destinationListen.fetchData({source,bookType,selectedTextArray:translatedTextArray})
// translatedTextArray
}
  return (
    popupShown ? <div id="tttModal" className={"opr-ttt-modal opr-flex-modal fade show"} style={languageDropdown ? {overflow:'hidden'} :null} tabIndex="-1" role="dialog" aria-labelledby="popupLabel">
      <div className="opr-ttt-dialog opr-modal-dialog opr-modal-dialog-centered" role="document">
        <div className="opr-modal-content">
          <div className="opr-modal-header">
            <audio ref={sourcAudioPlayer.audioRef}></audio>
            <audio ref={targetAudioPlayer.audioRef}></audio>
            <h2 className="opr-modal-title" style={{pointerEvents:'none'}} id="exampleModalCenterTitle">Translate</h2>
            <button type="button" onClick={closePopup} className="close opr-ttt-icons" data-dismiss="opr-flex-modal" aria-label="Close">
            </button>
          </div>

          <div className="opr-modal-body">
            <div className="opr-ttt-copy-wrap margin-bottom-30">
              <div className="opr-ttt-title-wrap margin-bottom-15">
                <label htmlFor="textarea">Source Text</label>
                {
                  sourcAudioPlayer.audioSources.length === 0 ?
                    <button onClick={() => sourceListenHandler()} className={`opr-ttt-icons opr-listen-btn ${errormsgDisplay && 'disabled'}`} aria-label="Listen">Listen</button>
                    :
                    sourcAudioPlayer.isPlaying ?
                      <button onClick={()=>{sourcAudioPlayer.pause()}}
                        className={`opr-ttt-icons opr-listen-btn opr-listen-pause`}
                        aria-label={`Pause`}>
                        {sourcAudioPlayer.isPlaying} Pause</button>
                      : <button onClick={ () => {targetAudioPlayer.pause();sourcAudioPlayer.play();}}
                        className={`opr-ttt-icons opr-listen-btn`} aria-label={`Listen`}> {sourcAudioPlayer.isPlaying} Listen</button>
                }
              </div>
              <div className="opr-ttt-copied-wrap opr-copied-text-bg">
                <textarea onChange={textareaChangeHandler} defaultValue={selectedTextData.trim()} readOnly={true} ref={textareaRef} id="textarea"></textarea>
                <div className="opr-ttt-validation">
                  <label className={"errorMessage " + errormessageDisplay}>The maximum character limit for translation at one time is 3000.</label>
                  <div className="opr-text-limit">
                    <label className={characterLengthExceed}>{textareaLen + ' '} </label>/<label>{' ' + 3000}</label>
                  </div>
                </div>
              </div>
            </div>

            <div className="opr-ttt-copy-wrap">
              <div className="opr-ttt-title-wrap margin-bottom-15">
                <div className={`dropdown ${popupDropdown} ${dropDownDisable}` }>
                  <button className="dropdown-toggle opr-dropdown-btn opr-ttt-icons" onClick={toggleDropdown} type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    {selectedLanguage ? selectedLanguage : 'Choose Language'}
                  </button>
                  <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                    {language.language.length ? language.language.map((items) => (
                      <button key={items.code} id={items.code} className="dropdown-item" onClick={onLanguageClickHandler}>{items.label}
                      </button>
                    )): null }
                  </div>

                </div>
                {
                  targetAudioPlayer.audioSources.length == 0 ?
                    <button onClick={() => destinationListenHandler()} className={`opr-ttt-icons opr-listen-btn ${dropDownDisable} ${(language.selectedLangaugeData.isTtsSupported) ? null : ' disabled'} ${(selectedLanguage === false)? " disabled":' '}`} aria-label="Listen">Listen</button>
                    :
                    targetAudioPlayer.isPlaying ?
                      <button onClick={()=>targetAudioPlayer.pause()}
                        className={`opr-ttt-icons opr-listen-btn opr-listen-pause ${(language.selectedLangaugeData.isTtsSupported ) ? null : ' disabled'}`}
                        aria-label={`Pause`}> Pause </button>
                      :
                      <button onClick={ () => {sourcAudioPlayer.pause();targetAudioPlayer.play();}}
                        className={`opr-ttt-icons opr-listen-btn ${(language.selectedLangaugeData.isTtsSupported ) ? null : ' disabled'}`} aria-label={`Pause`}> Listen </button>
                }
              </div>
              <div className="opr-ttt-copied-wrap opr-translate-text-bg">
              { 
              selectedLanguage === false ? 
              <label role="status" aria-live="polite">Please choose a language above in order<br/> to translate your text.</label> :
              skeleton ? <Skeleton /> : 
                          <textarea onChange={textareaChangeHandler} 
                                    // onKeyDown={keypressed} 
                                    // style={{pointerEvents:'none'}}
                                    readOnly={true}
                                    defaultValue={translatedText} 
                                    id="textarea">
                          </textarea>
               }
              </div>
            </div>
          </div>
        </div>
      </div>
    </div> : null
  );
};

export default Tttpopup;